// NotFound — friendly 404 with global search + quick links
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import type { CSSProperties } from "react";

const SUGGESTIONS = [
  { kind: "record", label: "AAPL — Apple Inc.", path: "/browse/instruments/AAPL" },
  { kind: "domain", label: "Instruments", path: "/browse/instruments" },
  { kind: "approval", label: "7 pending approvals", path: "/approvals" },
  { kind: "rule", label: "ISIN checksum valid", path: "/quality" },
];

const QUICKLINKS = [
  { l: "Dashboard", p: "/home" },
  { l: "Browse", p: "/browse/instruments" },
  { l: "Approvals", p: "/approvals" },
  { l: "Lineage", p: "/lineage" },
  { l: "Quality", p: "/quality" },
  { l: "Settings", p: "/settings" },
];

export function NotFound() {
  const loc = useLocation();
  const [q, setQ] = useState("");

  const hits = q ? SUGGESTIONS.filter(s => s.label.toLowerCase().includes(q.toLowerCase())) : [];

  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: "calc(100vh - 76px)", padding: 32 }}>
      <div style={{ maxWidth: 640, textAlign: "center" }}>
        <div style={{
          width: 120, height: 120, margin: "0 auto 24px",
          borderRadius: "var(--shape-pebble)",
          background: "linear-gradient(135deg, var(--md-primary), var(--md-tertiary))",
          display: "grid", placeItems: "center",
          font: "var(--t-display-md)", color: "var(--md-on-primary)", fontStyle: "italic", fontWeight: 400,
        }}>404</div>

        <div style={{ font: "var(--t-label-md)", color: "var(--md-tertiary)", letterSpacing: "0.12em" }}>
          PATH NOT FOUND
        </div>
        <h1 style={{ font: "var(--t-display-sm)", margin: "8px 0 12px" }}>
          We couldn't find <span style={{ fontStyle: "italic", fontWeight: 400 }}>{loc.pathname}</span>
        </h1>
        <p style={{ font: "var(--t-body-lg)", color: "var(--md-on-surface-var)" }}>
          The record, domain, or page you're looking for has moved or never existed. Try a search or pick a destination.
        </p>

        <div style={{ marginTop: 28, display: "flex", gap: 8, justifyContent: "center" }}>
          <input value={q} onChange={e => setQ(e.target.value)} autoFocus placeholder="Search records, domains, approvals…"
            style={{
              flex: 1, maxWidth: 420, padding: "12px 18px", borderRadius: "var(--r-pill)",
              border: "1px solid var(--md-outline-var)", background: "var(--md-sc-lowest)",
              color: "var(--md-on-surface)", font: "var(--t-body-lg)",
            }} />
        </div>

        {q && (
          <div style={{ marginTop: 12, textAlign: "left", display: "grid", gap: 4 }}>
            {hits.length === 0 ? (
              <div style={{ color: "var(--md-on-surface-var)", textAlign: "center" }}>No matches.</div>
            ) : hits.map(h => (
              <Link key={h.path} to={h.path} style={{
                display: "flex", justifyContent: "space-between", padding: "10px 14px",
                background: "var(--md-sc-lowest)", border: "1px solid var(--md-outline-var)",
                borderRadius: "var(--r-md)", textDecoration: "none", color: "var(--md-on-surface)",
              }}>
                <span>{h.label}</span>
                <span style={{ font: "var(--t-label-sm)", color: "var(--md-tertiary)", letterSpacing: "0.08em" }}>{h.kind.toUpperCase()}</span>
              </Link>
            ))}
          </div>
        )}

        <div style={{ marginTop: 32 }}>
          <div style={{ font: "var(--t-label-md)", color: "var(--md-tertiary)", letterSpacing: "0.12em", marginBottom: 10 }}>
            QUICK LINKS
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "center" }}>
            {QUICKLINKS.map(l => (
              <Link key={l.p} to={l.p} style={pillLink}>{l.l}</Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const pillLink: CSSProperties = {
  padding: "8px 18px", borderRadius: "var(--r-pill)",
  background: "var(--md-secondary-container)", color: "var(--md-on-secondary-container)",
  textDecoration: "none", font: "var(--t-label-lg)",
};

export default NotFound;
